module.exports = __webpack_public_path__ + "client/img/s_item_03.3f41de1a.png";